import React, { createContext, useState, useContext, ReactNode } from 'react';
import { Editor } from 'grapesjs';

interface BodyEditorContextType {
  editor: Editor | null;
  setEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
}

const BodyEditorContext = createContext<BodyEditorContextType | undefined>(undefined);

interface BodyEditorProviderProps {
  children: ReactNode;
}

export const BodyEditorProvider: React.FC<BodyEditorProviderProps> = ({ children }) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  return (
    <BodyEditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </BodyEditorContext.Provider>
  );
};

export const useBodyEditor = (): BodyEditorContextType => {
  const context = useContext(BodyEditorContext);
  if (!context) {
    throw new Error('useBodyEditor must be used within a BodyEditorProvider');
  }
  return context;
};
